var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w-full z-50 bg-white border-b border-grey-light px-8 py-4"},[_c('top-bar-resto-admin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }